import { mapActions, mapGetters, mapMutations } from 'vuex'

import { userAbFormsTableHead } from '../../../admins/helpers'
import AbFormDetailDialog from '@/components/ab-form/ab-form-detail-dialog/index.vue'

/**
 * "A/B" tab inside the student profile card — lists this user's A/B
 * submissions across all courses. Read-only; opens a detail dialog per row.
 */
export default {
	name: 'user-students-ab-forms',
	components: {
		AbFormDetailDialog
	},
	data () {
		return {
			page           : 1,
			showDetail     : false,
			selectedId     : null,
			togglingId     : null
		}
	},
	computed: {
		...mapGetters({
			items     : 'userAbForms/list',
			listLength: 'userAbForms/listLength',
			limit     : 'userAbForms/limit',
			skip      : 'userAbForms/skip',
			isLoading : 'userAbForms/isLoading'
		}),
		headers () {
			return userAbFormsTableHead()
		}
	},
	created () {
		this.fetchList({ userId: this.$route.params.id })
	},
	methods: {
		...mapActions({
			fetchList : 'userAbForms/GET_LIST',
			setOverride: 'userAbForms/SET_POINT_B_OVERRIDE'
		}),
		...mapMutations({
			changeSkip: 'userAbForms/CHANGE_SKIP'
		}),
		changePagination (index) {
			this.changeSkip(this.limit * (index - 1))

			this.fetchList({ userId: this.$route.params.id })
		},
		openDetail (item) {
			this.selectedId = item.id
			this.showDetail = true
		},
		async togglePointBOverride (item) {
			try {
				this.togglingId = item.id

				await this.setOverride({
					courseId: item.course_id,
					userId  : item.user_id,
					enabled : !item.point_b_override
				})

				this.$toasted.success(this.$t('success') || 'Saved')
				await this.fetchList({ userId: this.$route.params.id })
			} catch (e) {
				this.$toasted.error(this.$t('error') || 'Error')
			} finally {
				this.togglingId = null
			}
		},
		onDetailUpdated () {
			this.fetchList({ userId: this.$route.params.id })
		},
		sentimentColor (sentiment) {
			switch (sentiment) {
				case 'positive':
					return 'success'
				case 'negative':
					return 'error'
				case 'neutral':
					return 'grey'
				default:
					return 'grey lighten-1'
			}
		}
	},
	destroyed () {
		this.changeSkip(0)
	}
}
